import React, { Component } from "react";

export default class PageHeaderHome extends Component {
    render() {
        return (
            <a href='/' style={{ float: "bottom", color: "#000000",
                backgroundColor: "#343A40" }}>
                <p style={{ textAlign: "center", fontSize: "11px" }}>
                    Created by <span style={{ color: "#007BFF" }}>
                        Aniket Agnihotri</span> in
                    a magical, top secret laboratory.<br/>v1.2<br /></p>
            </a>
        );
    }
}
